import { RouterProvider, createBrowserRouter, Navigate } from "react-router-dom";
import "./App.css";
import Home from "./pages/Home";
import DeleteAccount from "./pages/DeleteAccount";

function App() {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <Home />,
    },
    {
      path: "/deleteaccount",
      element: <DeleteAccount />,
    },
    {
      path: "*",
      element: <Navigate to="/" replace />,
    },
  ]);

  return <RouterProvider router={router} />;
}

export default App;